import { Result } from "../../../common-models/Result";
import { HttpServiceBase } from "../../../common-services/Http/HttpServiceBase";
import { GetRecipeCollectionNotificationsByOrderInput } from "./GetRecipeCollectionNotificationsByOrderInput";
import { GetRecipeCollectionNotificationsByOrderOutput } from "./GetRecipeCollectionNotificationsByOrderOutput";

export class GetRecipeCollectionNotificationsByOrderService extends HttpServiceBase {

  handle = (input: GetRecipeCollectionNotificationsByOrderInput): Promise<Result<GetRecipeCollectionNotificationsByOrderOutput> | null> => {
    const promise = this.http.get<Result<GetRecipeCollectionNotificationsByOrderOutput>>(`${this.baseUrlSislogApi}/v2/order/${input.orderId}/recipe-collection-notifications`);
    return promise;
  }
}